import styled, { css } from 'styled-components';
import { colors, colorAliases } from '../../variables/colors.js';
import { deviceWidths } from '../../variables/widths.js';
import { transitions } from '../../variables/transitions.js';
import { fonts } from '../../variables/fonts.js';

var TextBox = styled.div.withConfig({
  displayName: "style__TextBox",
  componentId: "sc-aj16o5-0"
})(["background:", ";width:100%;", " ", " ", ""], colors.white, function (props) {
  return props.noPadding === false && css(["padding:32px 16px 40px;@media (min-width:", "){padding:40px 32px 48px;}"], deviceWidths.tablet);
}, function (props) {
  return props.shadow && css(["box-shadow:0 0 1px ", ";"], colorAliases.shadow);
}, function (props) {
  return props.noBackground && css(["background:none;"]);
});
var TextBoxContent = styled.div.withConfig({
  displayName: "style__TextBoxContent",
  componentId: "sc-aj16o5-1"
})(["", " ", " p:not(:last-child),ol:not(:last-child),ul:not(:last-child){margin-bottom:28px;}ol,ul{line-height:22px;}ol{list-style-position:inside;padding-left:4px;li{list-style-type:decimal;margin-bottom:4px;}}ul{max-width:400px;padding-left:12px;li{list-style-type:disc;margin:0 0 4px 8px;}}.sg-link-list,.sg-link-list li{list-style-type:none;margin:0;padding:0;}a:not([class]){border-bottom:", " solid 1px;color:", ";cursor:pointer;transition:border-color ", ",color ", ";}.no-touch & a:not([class]):hover{border-color:", ";color:", ";}h1{font-family:", ";font-size:36px;margin-bottom:20px;line-height:40px;}h2{font-family:", ";font-size:28px;margin-bottom:20px;line-height:28px;}h3{font-family:", ";font-size:24px;margin-bottom:4px;}h4{margin-bottom:4px;font-family:", "}strong{font-weight:700;}em,i{font-style:italic;}.preamble{font-family:", ";font-size:21px;font-weight:400;line-height:27px;margin-bottom:20px;}"], function (props) {
  return props.center && css(["margin:0 auto;text-align:center;"]);
}, function (props) {
  return props.noMaxWidth === false && css(["max-width:600px;"]);
}, colors.ocean, colors.ocean, transitions["default"], transitions["default"], colors.oceanL1, colors.oceanL1, fonts.bold, fonts.bold, fonts.bold, fonts.bold, fonts.regular);
var TextBoxPreamble = styled.div.withConfig({
  displayName: "style__TextBoxPreamble",
  componentId: "sc-aj16o5-2"
})(["font-family:", ";font-size:21px;font-weight:400;line-height:27px;margin-bottom:20px;"], fonts.regular);

export { TextBox, TextBoxContent, TextBoxPreamble };
//# sourceMappingURL=style.js.map
